import { first } from 'rxjs/operators';
import { Role, User } from './../user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-router',
  templateUrl: './link-router.component.html',
  styleUrls: ['./link-router.component.css']
})
export class LinkRouterComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

  user: User;

  ngOnInit() {
    console.log(this.route.snapshot.queryParams)
    this.authService.user$.pipe(first()).toPromise().then(user => {
      this.user = user;
      if (user) {
        if (user.hasRole(Role.CUSTOMER) && this.route.snapshot.queryParams['itinerary']) {
          let extras;
          if (this.route.snapshot.queryParams['day']) {
            extras = { queryParams: { day: this.route.snapshot.queryParams['day'] } }
          }
          this.router.navigate(['/customer/itineraries', this.route.snapshot.queryParams['itinerary']], extras);
        } else {
          console.warn("unmatched link", this.route.snapshot.url);
          this.router.navigate(['/']);
        }
      }
    });
  }

}
